// src/pages/Login.jsx
// ═══════════════════════════════════════════════════════════════════════════════
// 🔐 LOGIN - ESTILO eFIT
// Diseño profesional con paleta azul corporativa
// ═══════════════════════════════════════════════════════════════════════════════

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

const Login = ({ onLogin }) => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });
  const [cargando, setCargando] = useState(false);
  const [mostrarPassword, setMostrarPassword] = useState(false);

  const handleSubmit = async () => {
    if (!form.email || !form.password) {
      setMensaje({ texto: "⚠️ Por favor completa todos los campos", tipo: "error" });
      return;
    }

    try {
      setCargando(true);
      setMensaje({ texto: "", tipo: "" });

      const res = await api.post("/usuarios/login", {
        email: form.email,
        password: form.password,
      });

      const { token, usuario } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem(
        "usuario",
        JSON.stringify({
          id: usuario.id,
          nombre: usuario.nombre,
          email: usuario.email,
          rol: usuario.rol,
          departamento_id: usuario.departamento_id,
          departamento_nombre: usuario.departamento_nombre
        })
      );

      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      // Limpiar empresa de sesión anterior (puede ser de otro tenant)
      localStorage.removeItem('empresa_contable_id');
      localStorage.removeItem('empresa_contable_nombre');

      // Auto-seleccionar empresa contable si solo hay una activa sin PIN
      try {
        const empRes = await api.get('/empresas-contables');
        const lista = empRes.data.empresas || empRes.data;
        const activas = Array.isArray(lista) ? lista.filter(e => e.activa) : [];
        if (activas.length === 1 && !activas[0].tiene_pin) {
          localStorage.setItem('empresa_contable_id', activas[0].id);
          localStorage.setItem('empresa_contable_nombre', activas[0].nombre);
        }
      } catch (_) { /* No bloquear el login si falla */ }

      setMensaje({ texto: "✅ Inicio de sesión exitoso", tipo: "success" });

      if (onLogin) {
        onLogin(usuario);
      }

      setTimeout(async () => {
  try {
    if (usuario.rol === "visualizador") {
      navigate("/departamento/dashboard");
      return;
    }
    if (usuario.rol === "cajero" || usuario.rol === "supervisor_pos") {
      navigate("/pos");
      return;
    }
    navigate("/dashboard");
  } catch (error) {
    console.error("Error al determinar redirección:", error);
    navigate("/dashboard");
  }
}, 500);

    } catch (error) {
      console.error("Error en login:", error);
      const errorMsg = error.response?.data?.error || "Error al iniciar sesión. Verifica tus credenciales.";
      setMensaje({ texto: `❌ ${errorMsg}`, tipo: "error" });
    } finally {
      setCargando(false);
    }
  };

  return (
    <div style={styles.container}>
      {/* Fondo con patrones */}
      <div style={styles.backgroundPattern}>
        <div style={styles.patternCircle1}></div>
        <div style={styles.patternCircle2}></div>
        <div style={styles.patternCircle3}></div>
        <div style={styles.patternGrid}></div>
      </div>

      <div style={styles.loginCard}>
        {/* Header con gradiente eFIT */}
        <div style={styles.header}>
          <div style={styles.logoContainer}>
            <div style={styles.logoCircle}>
              <img src="/digera.png" alt="Logo" style={styles.logoImage} />
            </div>
          </div>
          <h1 style={styles.title}>Inventario Pro</h1>
          <p style={styles.subtitle}>Sistema de Gestión de Inventario</p>
          <div style={styles.headerDecoration}></div>
        </div>

        {/* Formulario */}
        <div style={styles.formContainer}>
          <h2 style={styles.formTitle}>
            <span style={styles.formTitleIcon}>👋</span>
            ¡Bienvenido!
          </h2>
          <p style={styles.formSubtitle}>Ingresa tus credenciales para continuar</p>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>📧</span>
              Correo Electrónico
            </label>
            <div style={styles.inputWrapper}>
              <input
                type="email"
                style={styles.input}
                placeholder="usuario@ejemplo.com"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
                disabled={cargando}
                onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e2e8f0';
                  e.target.style.boxShadow = 'none';
                }}
              />
            </div>
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>
              <span style={styles.labelIcon}>🔒</span>
              Contraseña
            </label>
            <div style={styles.passwordContainer}>
              <input
                type={mostrarPassword ? "text" : "password"}
                style={{...styles.input, paddingRight: '50px'}}
                placeholder="••••••••"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
                disabled={cargando}
                onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
                onFocus={(e) => {
                  e.target.style.borderColor = '#3b82f6';
                  e.target.style.boxShadow = '0 0 0 4px rgba(59, 130, 246, 0.1)';
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = '#e2e8f0';
                  e.target.style.boxShadow = 'none';
                }}
              />
              <button
                type="button"
                style={styles.eyeButton}
                onClick={() => setMostrarPassword(!mostrarPassword)}
                disabled={cargando}
              >
                {mostrarPassword ? "🙈" : "👁️"}
              </button>
            </div>
          </div>

          <button
            style={{
              ...styles.btnLogin,
              opacity: cargando ? 0.7 : 1,
              transform: cargando ? 'none' : 'translateY(0)',
            }}
            onClick={handleSubmit}
            disabled={cargando}
            onMouseEnter={(e) => {
              if (!cargando) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 8px 24px rgba(30, 58, 138, 0.4)';
              }
            }}
            onMouseLeave={(e) => {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 16px rgba(30, 58, 138, 0.3)';
            }}
          >
            {cargando ? (
              <span style={styles.btnLoadingContent}>
                <span style={styles.spinner}></span>
                Ingresando...
              </span>
            ) : (
              <span style={styles.btnContent}>
                <span style={styles.btnIcon}>🚀</span>
                Iniciar Sesión
              </span>
            )}
          </button>

          {/* Mensaje */}
          {mensaje.texto && (
            <div style={{
              ...styles.message,
              ...(mensaje.tipo === "success" ? styles.messageSuccess : styles.messageError)
            }}>
              {mensaje.texto}
            </div>
          )}
        </div>

        {/* Footer */}
        <div style={styles.footer}>
          <div style={styles.footerIcon}>💡</div>
          <div style={styles.footerContent}>
            <p style={styles.footerTitle}>¿No tienes cuenta?</p>
            <p style={styles.footerText}>
              Contacta al administrador para crear tu usuario
            </p>
          </div>
        </div>
      </div>

      {/* Versión */}
      <div style={styles.version}>
        <span>Inventario Pro v2.0</span>
        <span style={styles.versionDivider}>•</span>
        <span>Estilo eFIT</span>
      </div>

      {/* Estilos de animación */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(5deg); }
        }
        
        @keyframes pulse {
          0%, 100% { opacity: 0.4; transform: scale(1); }
          50% { opacity: 0.6; transform: scale(1.05); }
        }
        
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

// ═══════════════════════════════════════════════════════════════════════════════
// 🎨 ESTILOS eFIT - PALETA AZUL CORPORATIVA
// ═══════════════════════════════════════════════════════════════════════════════

const styles = {
  container: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 50%, #1e40af 100%)',
    padding: '20px',
    position: 'relative',
    overflow: 'hidden',
    fontFamily: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
  },

  // Background Pattern
  backgroundPattern: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: 0,
    pointerEvents: 'none',
  },
  patternCircle1: {
    position: 'absolute',
    width: '400px',
    height: '400px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
    top: '-100px',
    left: '-100px',
    animation: 'float 8s ease-in-out infinite',
  },
  patternCircle2: {
    position: 'absolute',
    width: '300px',
    height: '300px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)',
    bottom: '-50px',
    right: '-50px',
    animation: 'float 10s ease-in-out infinite reverse',
  },
  patternCircle3: {
    position: 'absolute',
    width: '200px',
    height: '200px',
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(255,255,255,0.06) 0%, transparent 70%)',
    top: '50%',
    right: '15%',
    animation: 'pulse 6s ease-in-out infinite',
  },
  patternGrid: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    backgroundImage: `
      linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
      linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)
    `,
    backgroundSize: '50px 50px',
  },

  // Login Card
  loginCard: {
    background: 'white',
    borderRadius: '24px',
    boxShadow: '0 25px 80px rgba(0, 0, 0, 0.4)',
    width: '100%',
    maxWidth: '460px',
    position: 'relative',
    zIndex: 1,
    overflow: 'hidden',
    animation: 'fadeIn 0.6s ease-out',
  },

  // Header
  header: {
    background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
    padding: '48px 32px 40px',
    textAlign: 'center',
    color: 'white',
    position: 'relative',
  },
  logoContainer: {
    marginBottom: '20px',
  },
  logoCircle: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    background: 'rgba(255, 255, 255, 0.15)',
    backdropFilter: 'blur(10px)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    border: '3px solid rgba(255, 255, 255, 0.2)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
  },
  logoImage: {
    width: '70%',
    height: '70%',
    objectFit: 'contain',
  },
  title: {
    margin: '0 0 8px 0',
    fontSize: '32px',
    fontWeight: '800',
    letterSpacing: '-0.5px',
    textShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  subtitle: {
    margin: '0',
    fontSize: '15px',
    opacity: '0.9',
    fontWeight: '500',
  },
  headerDecoration: {
    position: 'absolute',
    bottom: '-1px',
    left: '0',
    right: '0',
    height: '30px',
    background: 'white',
    borderRadius: '24px 24px 0 0',
  },

  // Form Container
  formContainer: {
    padding: '32px 36px 36px',
  },
  formTitle: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#1e293b',
    marginBottom: '8px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  formTitleIcon: {
    fontSize: '28px',
  },
  formSubtitle: {
    fontSize: '14px',
    color: '#64748b',
    marginBottom: '28px',
  },
  formGroup: {
    marginBottom: '22px',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#374151',
    marginBottom: '10px',
  },
  labelIcon: {
    fontSize: '16px',
  },
  inputWrapper: {
    position: 'relative',
  },
  input: {
    width: '100%',
    padding: '16px 18px',
    fontSize: '15px',
    border: '2px solid #e2e8f0',
    borderRadius: '14px',
    outline: 'none',
    transition: 'all 0.3s ease',
    boxSizing: 'border-box',
    background: '#f8fafc',
  },
  passwordContainer: {
    position: 'relative',
  },
  eyeButton: {
    position: 'absolute',
    right: '14px',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'transparent',
    border: 'none',
    cursor: 'pointer',
    fontSize: '20px',
    padding: '6px',
    borderRadius: '8px',
    transition: 'all 0.2s ease',
  },

  // Login Button
  btnLogin: {
    width: '100%',
    padding: '18px',
    background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
    color: 'white',
    border: 'none',
    borderRadius: '14px',
    fontSize: '17px',
    fontWeight: '700',
    cursor: 'pointer',
    marginTop: '8px',
    boxShadow: '0 4px 16px rgba(30, 58, 138, 0.3)',
    transition: 'all 0.3s ease',
  },
  btnContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
  },
  btnIcon: {
    fontSize: '20px',
  },
  btnLoadingContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '12px',
  },
  spinner: {
    width: '20px',
    height: '20px',
    border: '3px solid rgba(255,255,255,0.3)',
    borderTopColor: 'white',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },

  // Messages
  message: {
    padding: '14px 18px',
    borderRadius: '12px',
    marginTop: '20px',
    fontSize: '14px',
    fontWeight: '600',
    textAlign: 'center',
    animation: 'fadeIn 0.3s ease-out',
  },
  messageSuccess: {
    background: 'linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%)',
    color: '#065f46',
    border: '1px solid #6ee7b7',
  },
  messageError: {
    background: 'linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)',
    color: '#991b1b',
    border: '1px solid #fca5a5',
  },

  // Footer
  footer: {
    background: 'linear-gradient(180deg, #f8fafc 0%, #eff6ff 100%)',
    padding: '24px 36px',
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    borderTop: '1px solid #e2e8f0',
  },
  footerIcon: {
    fontSize: '32px',
    background: 'linear-gradient(135deg, #fef3c7 0%, #fde68a 100%)',
    padding: '12px',
    borderRadius: '12px',
  },
  footerContent: {
    flex: 1,
  },
  footerTitle: {
    margin: '0 0 4px 0',
    fontSize: '14px',
    fontWeight: '700',
    color: '#1e293b',
  },
  footerText: {
    margin: '0',
    fontSize: '13px',
    color: '#64748b',
  },

  // Version
  version: {
    position: 'absolute',
    bottom: '20px',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: 'rgba(255, 255, 255, 0.6)',
    fontSize: '12px',
    fontWeight: '500',
  },
  versionDivider: {
    opacity: '0.4',
  },
};

export default Login;